var isObject = require('../internals/is-object');

var classof = require('../internals/classof-raw');

var MATCH = require('../internals/well-known-symbol')('match'); // `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp


module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};